<div *ngIf="customerGroupings">
  <grouping-body-title
    [name]="customerGroupings.name"
    [selectedDataConfig]="selectedDataConfig"
    (toggledEvent)="visibilityToggled($event)"
  ></grouping-body-title>
  <div class="description">
    <div class="config-details">
      <p class="desc-title">
        How do I group my {{ customerGroupings.name }} values?
      </p>
      <p>
        Assign your {{ customerGroupings.groupingUnitPlural }} into the correct
        categories by selecting one or more
        {{ customerGroupings.groupingUnitPlural }}, choosing a destination
        category from the dropdown below, and clicking "MOVE".
        <span *ngIf="customerGroupings.groupingTemplateId == '3'">
          The Course Failure metrics use grades from "Is a Core Course"
          category. Grades from "Is Not a Core Course" category are excluded
          from the dataset.
        </span>
        <span *ngIf="customerGroupings.groupingTemplateId == '10'">
          The listed values come from Grade Period Abbreviation in the data
          warehouse. We recommend editing category names to be fewer than 10
          characters for best display on the trend line chart.
        </span>
        <span *ngIf="customerGroupings.groupingTemplateId == '11'">
          Configuration is currently only available for Illuminate. The values
          in Is Benchmark Test category should reflect ALL district-created
          benchmarks test types. These are used to identify the set of tests
          that may be used to calculate any district-benchmark metric. Each
          metric may have additional data set filters – such as one test subject
          or or one district benchmark value – that can be applied per tile via
          support.
        </span>
        <span *ngIf="customerGroupings.groupingTemplateId == '13'">
          The listed values come from Term Abbreviation in the data warehouse.
          We recommend editing category names to be fewer than 10 characters for
          best display on the trend line chart. This data configuration is used
          by Course Failure and GPA metrics.
        </span>
        <span *ngIf="customerGroupings.groupingTemplateId == '14'">
          The Office Discipline Referral metrics use any behaviors in the
          "Office-Managed (Minor, Major)" and "Uncategorized" categories.
          Behaviors from the "Other Exclusions" and "Classroom-Managed (Minor)"
          categories are not counted towards Office Discipline Referral metrics.
        </span>
      </p>
    </div>
    <div
      class="field-mapping-details"
      *ngIf="customerGroupings.fieldMappingDefinition"
    >
      <p class="desc-title">
        Where do these values come from in my student information system?
      </p>
      <p class="field-mapping">
        <span
          *ngIf="truncatedDefinition && !expandedView"
          [innerHtml]="truncatedDefinition"
        ></span>
        <span
          *ngIf="!truncatedDefinition || expandedView"
          [innerHtml]="definition"
        ></span>
      </p>
      <div *ngIf="truncatedDefinition">
        <button
          class="btn btn-link expand-btn"
          *ngIf="!expandedView"
          (click)="expandedView = true"
        >
          Show more
          <img
            [src]="'../../assets/images/show_more_gray600.png'"
            class="toggleShowImg"
          />
        </button>
        <button
          class="btn btn-link expand-btn"
          *ngIf="expandedView"
          (click)="expandedView = false"
        >
          Show less
          <img
            [src]="'../../assets/images/show_less_gray600.png'"
            class="toggleShowImg"
          />
        </button>
      </div>
    </div>
  </div>
</div>
<span *ngIf="loadingData && !groupingService.hasError">
  <p class="loading">Loading...</p>
</span>
<mat-card
  *ngIf="loadingData && groupingService.hasError"
  class="load-error"
  [innerHTML]="groupingService.errorMessage"
>
</mat-card>
<span *ngIf="!loadingData && !customerGroupings && !groupingService.hasError">
  <grouping-body-title
    [name]="getAggGroupName()"
    [selectedDataConfig]="selectedDataConfig"
    (toggledEvent)="visibilityToggled($event)"
  ></grouping-body-title>
  <mat-card *ngIf="isGradeLevelAtTheTime()">
    Go to
    <button
      mat-button
      class="currentGradeLevelBtn"
      (click)="goToCurrentGradeLevel()"
    >
      Current Grade Level
    </button>
    to assign grade level values to groups. You can still show or hide Grade
    Level at the Time on your dashboards using the toggle at the upper right.
  </mat-card>
  <mat-card *ngIf="!isGradeLevelAtTheTime()">
    {{ getAggGroupName() }} is a binary field and therefore is not configurable.
    You can still show or hide {{ getAggGroupName() }} on your dashboards using
    the toggle at the upper right.
  </mat-card>
</span>
<move-panel
  *ngIf="!loadingData && customerGroupings"
  [codeName]="customerGroupings?.groupingUnit"
  [customerGroups]="customerGroupings?.customerGroups"
  [codesSelected]="codesSelected"
  (moveEvent)="moveSelectedCodes($event)"
></move-panel>
<div class="changes-saved-text" *ngIf="saveInProgress">Saving!</div>
<div class="save-error-text" *ngIf="saveError">
  Sorry, we hit an error. Please try again later!
</div>
<div class="save-btn-div" *ngIf="areChangesToBeSaved">
  <button mat-raised-button (click)="saveChanges()" class="save-btn green-btn">
    SAVE CHANGES
  </button>
</div>
<div class="groups">
  <group
    #myGroups
    *ngFor="let group of customerGroupings?.customerGroups"
    [showLeftArrow]="showLeftArrow(group)"
    [showRightArrow]="showRightArrow(group)"
    [groupData]="group"
    [canBeDeleted]="customerGroupings?.isEditable"
    [groupingUnitPlural]="customerGroupings?.groupingUnitPlural"
    [groupingTemplateId]="groupingTemplateId"
    (groupSelected)="groupSelected($event)"
    (groupEdited)="editGroup($event)"
    (groupDeleted)="deleteGroup($event)"
    (groupMovedLeft)="moveGroupLeft($event)"
    (groupMovedRight)="moveGroupRight($event)"
    class="group"
  ></group>
  <div class="new-category" *ngIf="customerGroupings?.isEditable">
    <button
      mat-raised-button
      (click)="newCategory()"
      class="new-category-btn green-btn"
    >
      + NEW CATEGORY
    </button>
  </div>
</div>
